import { HttpClient } from '@angular/common/http';
import { asLiteral } from '@angular/compiler/src/render3/view/util';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { elementAt } from 'rxjs';
import { CommonService } from 'src/app/services/common.service';
import {
  ResponseMessageStatus,
  ResponseStatus,
  SortBy,
  StockLocation,
} from 'src/app/shared/enums';
import { BadeLoftService } from '../bade-loft.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],
})
export class DashboardComponent implements OnInit {
  //#region properties
  lst_Dashboard: any = [];
  lst_Stock: any = [];
  sortField: string = 'name';
  sortBy: number = SortBy.Asc;
  page: number = 1;
  pageSize: number = 100;
  totalRecord: number = 0;
  searchText: string = '';
  oldSearchText: string = '';
  timer: any = null;
  stockLocation: typeof StockLocation;
  assignedData: any;
  isDashboardLoaded: boolean = false;
  dashboardMaxPageSize: number = 0;
  dashboardList_Request: any;
  isVisible = false;
  stockAssignment: any;
  isStockLoaded: boolean = false;
  editId: any;
  selectedPINumber: any;
  sortPartNumberBy: any = SortBy.Asc;
  addPIClicked = false;
  //#endregion

  //#region functions
  onScrollDown() {
    if (this.page != this.dashboardMaxPageSize) {
      this.page += 1;
      this.getDashboardList();
    }
  }

  getDashboardList() {
    this.isDashboardLoaded = true;
    this._cdref.detectChanges();
    try {
      this.dashboardList_Request = this._blS
        .DashboardData(
          encodeURIComponent(this.searchText.trim()),
          this.sortField,
          this.sortBy,
          this.page,
          this.pageSize,
          false
        )
        .subscribe((res) => {
          if (res) {
            if (res.responseStatus == ResponseStatus.Success && res.result) {
              var data = res.result;
              if (this.page == 1) this.lst_Stock = data.stock;
              this.isDashboardLoaded = false;
              this.totalRecord = data.totalRecord;
              this.dashboardMaxPageSize = res.result.totalPage;
              if (data.dashboardData && data.dashboardData.length > 0) {
                data.dashboardData.forEach((x: any) => {
                  this.lst_Dashboard.push(x);
                });
                this.lst_Dashboard.map((d: any) => (d.visibleAssigned = false));
                this.lst_Dashboard.map(
                  (d: any) => (d.visibleN2OAssigned = false)
                );
              }
              this.lst_Dashboard.forEach((item: any) => {
                this.lst_Stock.forEach((itemstock: any): any => {
                  var OrderQuantity = 0;
                  if (itemstock.partNumbers != null) {
                    var PartQuanaity = itemstock.partNumbers.find(
                      (p: any) => p.partNumber == item.partNumber
                    );
                    if (PartQuanaity != null) {
                      OrderQuantity = PartQuanaity.orderedQuantity;
                    }
                  }
                  itemstock.partNumbers.map(
                    (p: any) => (p.visibleAssigned = false)
                  );
                  itemstock.partNumbers.map(
                    (p: any) => (p.visibleN2OAssigned = false)
                  );
                });
              });
              var objEmptyelement =
                document.getElementsByClassName('orderedQuantity');
              setTimeout(() => {
                if (objEmptyelement.length > 0) {
                  for (let i = 0; i < objEmptyelement.length; i++) {
                    if (objEmptyelement[i].children.length == 0) {
                      let div = document.createElement('span');
                      div.className = 'restrict-pointer';
                      div.innerHTML = '0';
                      objEmptyelement[i].appendChild(div);
                    }
                  }
                }
              }, 100);
            } else {
              this._cS.displayMessage(ResponseMessageStatus.error, res.message);
              this.isDashboardLoaded = false;
            }
            var local_data = {
              searchText: this.searchText,
              sortBy: this.sortBy,
              sortField: this.sortField,
            };
            this._cS.setLocalStorageItem(
              'dashboard_data',
              JSON.stringify(local_data)
            );
          }
        });
    } catch (error) {}
  }

  onSearch(event: any) {
    if (event.which != 9 && event.which != 18 && event.which != 27) {
      clearTimeout(this.timer);
      if (this.searchText.trim().length >= 3) {
        this.timer = setTimeout(() => {
          this.page = 1;
          this.lst_Dashboard = [];
          if (this.dashboardList_Request)
            this.dashboardList_Request.unsubscribe();
          this.getDashboardList();
        }, 1000);
      } else {
        if (this.searchText == '') {
          this.oldSearchText = '';
          this.page = 1;
          this.lst_Dashboard = [];
          if (this.dashboardList_Request)
            this.dashboardList_Request.unsubscribe();
          this.getDashboardList();
        }
      }
    }
  }
  sort(key: string) {
    if (key) {
      this.sortBy = this.sortBy == SortBy.Asc ? SortBy.Dsc : SortBy.Asc;
      this.sortField = key;
      this.page = 1;
      this.lst_Dashboard = [];
      if (this.dashboardList_Request) this.dashboardList_Request.unsubscribe();
      this.getDashboardList();
    }
  }
  isAssignmentVisible: boolean = false;
  editAssignmentDetail: any = null;
  stockAssignmentDetail: any = null;
  showAssignmentEdit(assignment: any, stock: any) {
    // this._router.navigate(['/bade-loft/assignment'], {
    //   queryParams: { invoiceNumber: invoice },
    // });
    this.isAssignmentVisible = true;
    this.assignedData = null;
    this.editAssignmentDetail = assignment;
    this.editAssignmentDetail['assigmentDetails'] = true;
    this.stockAssignmentDetail = stock;
  }
  hideModal(event: any) {
    if (event.hide) {
      this.isAssignmentVisible = !event.hide;
      if (event.data) {
        this.isStockLoaded = true;
        if (this.stockAssignmentDetail.name != 'N2O') {
          if (this.stockAssignmentDetail.stockId) {
            this._blS
              .GetStockAssignmentDetail(this.stockAssignmentDetail.stockId)
              .subscribe((res) => {
                if (res) {
                  if (res.responseStatus == ResponseStatus.Success) {
                    this.stockAssignment = res.result ? res.result : [];
                  }
                }
                this.isStockLoaded = false;
              });
          }
        } else {
          this.getN2OStockAssignmentDetail();
        }
      }
      this.lst_Dashboard = [];
      this.getDashboardList();
    }
  }
  changeAssigned(event: any, s: number, p: number) {
    this.lst_Stock[s].partNumbers[p].visibleAssigned = event;
    this.assignedData = null;
    // if (this.lst_Stock[s].partNumbers[p].visibleAssigned) {
    //   this.assignedData = null;
    //   this.assignedData = this.lst_Stock[s].partNumbers[p]
    //     ? this.lst_Stock[s].partNumbers[p]
    //     : [];
    //   this.assignedData.assignmentList = this._blS.getUniqueAssignedList(
    //     this.assignedData
    //   );
    // }
    this._blS
      .GetPartNumberAssignmentDetail(
        this.lst_Stock[s].partNumbers[p].partNumber,
        this.lst_Stock[s].stockId
      )
      .subscribe((res) => {
        if (res) {
          if (res.responseStatus == ResponseStatus.Success) {
            this.assignedData =
              res.result && res.result.length > 0 ? res.result[0] : [];
          }
        }
      });
  }

  changeDahboardAssigned(event: any, i: number) {
    if (this.lst_Dashboard[i].warehouseAssignedQuantity > 0) {
      this.lst_Dashboard[i].visibleAssigned = event;

      if (
        this.lst_Dashboard[i].visibleAssigned &&
        !this.lst_Dashboard[i].assignedData
      ) {
        this._blS
          .GetPartNumberAssignmentDetail(this.lst_Dashboard[i].partNumber)
          .subscribe((res) => {
            if (res) {
              if (res.responseStatus == ResponseStatus.Success) {
                this.lst_Dashboard[i].assignedData =
                  res.result && res.result.length > 0 ? res.result : [];
                // this.lst_Dashboard[i]['assignmentList'] =
                //   res.result && res.result.length > 0
                //     ? res.result[0].assignmentList
                //     : [];
              }
            }
          });
      }
    }
  }
  changeN2OAssigned(event: any, i: number) {
    if (this.lst_Dashboard[i].n2OAssignedQuantity > 0) {
      this.lst_Dashboard[i].visibleN2OAssigned = event;
      if (
        this.lst_Dashboard[i].visibleN2OAssigned &&
        !this.lst_Dashboard[i].assignedData
      ) {
        this._blS
          .GetN2OPartNumberAssignmentDetail(this.lst_Dashboard[i].partNumber)
          .subscribe((res) => {
            if (res) {
              if (res.responseStatus == ResponseStatus.Success) {
                this.lst_Dashboard[i].assignedData =
                  res.result && res.result.length > 0 ? res.result : [];
              }
            }
          });
      }
    }
  }
  saveSelectedPI(partAssignStock: any, stockAssignment: any) {
    this._blS
      .UpdateN2OAssignnmentStocksDetail(
        partAssignStock.id,
        stockAssignment.partNumber,
        partAssignStock.isChecked,
        partAssignStock.tempPINumber || ''
      )
      .subscribe((response: any) => {
        if (response.responseStatus == ResponseStatus.Success) {
          partAssignStock.piNumber = response.result.piNumber;
        }
        this._cS.displayMessage(
          ResponseMessageStatus.success,
          response.message
        );
      });
  }
  //for editable cells
  startEdit(id: any, piNumber: any): void {
    this.editId = id;
    this.selectedPINumber = piNumber;
  }

  stopEdit(): void {
    this.editId = null;
  }

  showModal(stockId: any): void {
    this.isVisible = true;
    this.isStockLoaded = true;
    this._blS.GetStockAssignmentDetail(stockId).subscribe((res) => {
      if (res) {
        if (res.responseStatus == ResponseStatus.Success) {
          this.stockAssignment = res.result ? res.result : [];
        }
      }
      this.isStockLoaded = false;
    });
  }
  showN2OModal(): void {
    this.isVisible = true;
    this.isStockLoaded = true;
    this.getN2OStockAssignmentDetail();
  }
  getN2OStockAssignmentDetail() {
    this.isStockLoaded = true;
    this._blS
      .GetN2OStockAssignmentDetail(this.sortPartNumberBy)
      .subscribe((res) => {
        if (res) {
          if (res.responseStatus == ResponseStatus.Success) {
            this.isStockLoaded = false;
            this.stockAssignment = res.result ? res.result : [];
            this.stockAssignment.stockPartNumbers.forEach(
              (stAssignement: any) => {
                stAssignement.stockPartNumberAssignmentsStock.forEach(
                  (element: any) => {
                    element.addPIClicked = false;
                    element.tempPINumber = element.piNumber;
                  }
                );
              }
            );
          } else {
            this.isStockLoaded = true;
            this._cS.displayMessage(ResponseMessageStatus.error, res.message);
          }
        } else {
          this.isStockLoaded = true;
          this._cS.displayMessage(
            ResponseMessageStatus.error,
            'Something went wrong'
          );
        }
      });
  }

  handleOk(): void {
    this.isVisible = false;
  }
  handleCancel(): void {
    this.isVisible = false;
  }

  isAscPart: boolean = true;
  sortPart(isAsc: any, data: any) {
    this.isAscPart = isAsc;
    var ar = data.sort(function (a: any, b: any) {
      var nA = isAsc ? a.partNumber.toLowerCase() : b.partNumber.toLowerCase();
      var nB = isAsc ? b.partNumber.toLowerCase() : a.partNumber.toLowerCase();

      if (nA < nB) return -1;
      else if (nA > nB) return 1;
      return 0;
    });
    data = ar;
  }
  sortN2OPartNumber() {
    this.sortPartNumberBy =
      this.sortPartNumberBy == SortBy.Asc ? SortBy.Dsc : SortBy.Asc;
    this.getN2OStockAssignmentDetail();
  }
  //#endregion
  constructor(
    private _cS: CommonService,
    private _blS: BadeLoftService,
    private _cdref: ChangeDetectorRef,
    private _router: Router
  ) {
    this.stockLocation = StockLocation;
  }

  ngOnInit(): void {
    var preReservedData: any = null;
    preReservedData = this._cS.getLocalStorageItem('dashboard_data');
    if (preReservedData) {
      preReservedData = JSON.parse(preReservedData);
      // this.page = preReservedData.page;
      // this.pageSize = preReservedData.pageSize;
      this.searchText = preReservedData.searchText;
      this.sortBy = preReservedData.sortBy;
      this.sortField = preReservedData.sortField;
    }
    setTimeout(() => {
      this.getDashboardList();
    }, 100);
  }
}
